import { TextField } from '@app/components/form-fields/TextField';
import type { AINumberListParams } from '@app/services/number.types';
import { debounce } from 'lodash';
import { useEffect, useState } from 'react';
import { MdSearch } from 'react-icons/md';

export type NumberFiltersProps = {
    onChange: (values: AINumberListParams) => void;
};

export const NumberFilters = ({ onChange }: NumberFiltersProps) => {
    const [filterSelection, setFilterSelection] = useState<AINumberListParams>({
        search: '',
        page: 1,
        per_page: 10,
    });

    useEffect(() => {
        onChange(filterSelection);
    }, [filterSelection]);

    return (
        <div>
            <TextField
                placeholder="Search AI Numbers..."
                prefix={<MdSearch size={20} />}
                onChange={debounce((e) => {
                    setFilterSelection((prev) => ({
                        ...prev,
                        search: e.target.value,
                    }));
                }, 500)}
            />
        </div>
    );
};

export default NumberFilters;
